import { h } from 'preact'
import 'whatwg-fetch'
/** @jsx h */
import { useAppState } from '../state/Quiz.context'

export const WizardResult = () => {
  const [{ wizard, quiz, results }, dispatch] = useAppState()
  const result = results.items[wizard.current]

  const jsonAnswers = []
  Object.entries(quiz).map(question => {
    console.log()
    const quizTitle = question[0]
    const answers = question[1]

    Object.entries(answers).map(answer => {
      Object.entries(answer[1]).map(option => {
        if (option[1].selected) {
          jsonAnswers.push({ vraag: quizTitle, antwoord: option[0] })
        }
      })
    })
  })

  if (result.url) {
    location.href = result.url + `?answers=${JSON.stringify(jsonAnswers)}`
  }

  console.log(quiz)

  return (
    <div className="c-quiz__results">
      <div className="c-quiz__result-body">
        <div
          className="u-squeeze--xs"
          dangerouslySetInnerHTML={{ __html: result.content }}
        />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/js/quiz/components/WizardResult.jsx